import { render } from "./AvatarImageCrop.vue?vue&type=template&id=2047e802"
import script from "./AvatarImageCrop.vue?vue&type=script&lang=js"
export * from "./AvatarImageCrop.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__